<ng-container *ngrxLet="orgData$; let orgData">
    <h1>{{ orgData.product }}</h1>
    <h2>{{ orgData.productType }}</h2>
    <h2>{{ orgData.variant }}</h2>
</ng-container>
<ng-container *ngrxLet="sortedInputFields$; let sortedInputFields">
    @for (inputField of sortedInputFields; track trackByFn($index, inputField)) {
        <pace-customer-identification-input-field
            class="col"
            [parentForm]="parentForm"
            [property]="inputField.key"
        ></pace-customer-identification-input-field>
    }
</ng-container>
@if (instructions$ | async; as instructions) {
    <p>{{ instructions }}</p>
}
<ng-container *ngrxLet="copyright$; let copyright">
    <p>{{ copyright.line1 }}</p>
    <p>{{ copyright.line2 }}</p>
</ng-container>
